































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import UnitRuangPicker from "@/components/common/UnitRuangPicker.vue";
import {
  PPI_CAKUPAN_ITEMS,
  PpiRekapCakupan,
  ppiCakupanPicker
} from "@/utils/unit";
import Service from "@/services/AlatReuseService";
import { MasterAlatReuse, PenggunaanAlatReuse } from "@/types/alat_reuse";

@Component({ components: { UnitRuangPicker } })
export default class PpiRekapAlatReusePage extends Vue {
  filter: {
    tgl_dari: string;
    tgl_sampai: string;
    unit_id: string | null;
    cakupan: string;
    master_alat_reuse_id: number | null;
    search: string;
  } = {
    tgl_dari: "",
    tgl_sampai: "",
    unit_id: null,
    cakupan: "ranap",
    master_alat_reuse_id: null,
    search: ""
  };

  cakupanItems = PPI_CAKUPAN_ITEMS;

  options: any = { page: 1, itemsPerPage: 20 };
  rows: PenggunaanAlatReuse[] = [];
  masterOptions: MasterAlatReuse[] = [];
  total = 0;
  loading = false;

  headers = [
    { text: "Nama Pasien", value: "nama_pasien" },
    { text: "No. RM", value: "pasien_rm", width: 90 },
    { text: "Jenis Alat Reuse", value: "alat" },
    { text: "Kode Unit Alat", value: "kode_unit_alat", width: 130 },
    { text: "Tgl Penggunaan", value: "tanggal_penggunaan", width: 130 },
    { text: "Jenis Tindakan", value: "jenis_operasi" },
    { text: "Ruang Rawat", value: "ruang_rawat", width: 150 },
    { text: "Tgl Steril", value: "tanggal_sterilisasi", width: 120 },
    { text: "Mode Steril", value: "metode_sterilisasi", width: 130 }
  ];

  mounted() {
    this.loadMasterOptions();
  }

  get pickerCfg() {
    return ppiCakupanPicker(this.filter.cakupan as PpiRekapCakupan);
  }

  onCakupanChange() {
    this.reload();
  }

  reload() {
    if (this.options.page !== 1) {
      this.options = { ...this.options, page: 1 };
      return; // watcher options akan memuat data
    }
    this.loadData();
  }

  @Watch("options", { deep: true })
  onOptionsChange() {
    this.loadData();
  }

  get params() {
    return {
      tgl_dari: this.filter.tgl_dari || undefined,
      tgl_sampai: this.filter.tgl_sampai || undefined,
      unit_id: this.filter.unit_id || undefined,
      cakupan: this.filter.unit_id ? undefined : this.filter.cakupan,
      master_alat_reuse_id: this.filter.master_alat_reuse_id || undefined,
      search: this.filter.search || undefined
    };
  }

  async loadData() {
    this.loading = true;
    try {
      const res = await Service.penggunaanList({
        params: {
          ...this.params,
          page: this.options.page,
          per_page: this.options.itemsPerPage
        }
      });
      const d = res.data.data;
      this.rows = d.data || [];
      this.total = d.total || 0;
    } finally {
      this.loading = false;
    }
  }

  async loadMasterOptions() {
    const res = await Service.masterList({ params: { per_page: 200 } });
    const d = res.data.data;
    this.masterOptions = d.data || d || [];
  }

  printPdf() {
    Service.printPenggunaanPdf(this.params as Record<string, any>);
  }

  formatDate(s?: string | null) {
    if (!s) return "-";
    return new Date(s).toLocaleDateString("id-ID");
  }
}
